document.addEventListener("DOMContentLoaded", function () {

    if (typeof jQuery !== "undefined") {

        jQuery('#testimonial_slider').owlCarousel({
            loop: true,
            margin: 10,
            dots: false,
            nav: true,
            responsiveClass: true,
            navText: [
                '<i class="fa-sharp fa-regular fa-arrow-left-long rounded_icon d-inline-flex justify-content-center align-items-center"></i>',
                '<i class="fa-sharp fa-regular fa-arrow-right-long rounded_icon d-inline-flex justify-content-center align-items-center"></i>'
            ],
            responsive: {
                0: { items: 1 },
                600: { items: 1, nav: true },
                1000: { items: 1, loop: true }
            }
        });

        jQuery('#services_slider').owlCarousel({
            loop: true,
            margin: 10,
            dots: true,
            nav: false,
            responsiveClass: true,
            navText: [
                '<i class="fa-sharp fa-regular fa-arrow-left-long rounded_icon d-inline-flex justify-content-center align-items-center"></i>',
                '<i class="fa-sharp fa-regular fa-arrow-right-long rounded_icon d-inline-flex justify-content-center align-items-center"></i>'
            ],
            responsive: {
                0: { items: 1, dots: true },
                600: { items: 1 },
                1000: { items: 1 }
            }
        });

        jQuery('#trust_slider').owlCarousel({
            loop: true,
            margin: 10,
            dots: false,
            nav: true,
            responsiveClass: true,
            navText: [
                '<i class="fa-sharp fa-regular fa-arrow-left-long rounded_icon d-inline-flex justify-content-center align-items-center"></i>',
                '<i class="fa-sharp fa-regular fa-arrow-right-long rounded_icon d-inline-flex justify-content-center align-items-center"></i>'
            ],
            responsive: {
                0: { items: 1, nav: true },
                600: { items: 1, nav: true },
                1000: { items: 1, nav: true }
            }
        });
          jQuery('#packages_slider').owlCarousel({
             loop:true,
             margin:10,
             dots: true,
             nav: true,
             items: 1,
             responsiveClass:true,
              navText: [
             '<i class="fa-sharp fa-regular fa-arrow-left-long rounded_icon d-inline-flex justify-content-center align-items-center"></i>',
             '<i class="fa-sharp fa-regular fa-arrow-right-long rounded_icon d-inline-flex justify-content-center align-items-center "></i>'],
});

    }

});
// sticky header on scroll
const header = document.querySelector('header');

window.addEventListener('scroll', function () {
    if (window.scrollY > 100) {
        // document.body.style.paddingTop = header.offsetHeight + 'px';
        header.classList.add('sticky');
    } else {
        document.body.style.paddingTop = '0';
        header.classList.remove('sticky');
    }
});


 (function () {
    var bar = document.getElementById('bw-sticky-bar');
    if (!bar) return;

    var offset = 0; // thora pehle chahiye to 100-150 karein

    function getBanner() {
      var all = document.querySelectorAll('.banner_section');
      for (var i = 0; i < all.length; i++) {
        if (all[i].getBoundingClientRect().height > 0) return all[i];
      }
      return null;
    }

    function toggleBar() {
      // Desktop: hamesha visible
      if (window.innerWidth > 768) {
        bar.classList.add('is-visible');
        return;
      }

      var banner = getBanner();
      var passed;

      if (banner) {
        passed = banner.getBoundingClientRect().bottom <= offset;
      } else {
        // Fallback: banner na mile to 80% screen scroll ke baad
        passed = window.scrollY > window.innerHeight * 0.8;
      }

      bar.classList.toggle('is-visible', passed);
    }

    window.addEventListener('scroll', toggleBar, { passive: true });
    window.addEventListener('resize', toggleBar);
    window.addEventListener('load', toggleBar);
    toggleBar();
  })();